import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useManualQuery } from 'graphql-hooks';
import { useAtomValue } from 'jotai';

import { OPEN_REPORTS_COUNT } from '../graphql/report/query';
import { reportsUpdatedAtom } from '../atoms';

// Open reports of the admin, read again on each page change and each time a report is handled.
const useOpenReportsCount = (enabled: boolean) => {
  const { pathname } = useLocation();
  const [openReportsCount] = useManualQuery(OPEN_REPORTS_COUNT, { skipCache: true });
  const [count, setCount] = useState(0);
  const reportsUpdated = useAtomValue(reportsUpdatedAtom);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    let active = true;
    const getCount = async () => {
      const { data } = await openReportsCount() as any;
      if (active && data && typeof data.openReportsCount === 'number') {
        setCount(data.openReportsCount);
      }
    };
    getCount();
    return () => {
      active = false;
    };
  }, [enabled, openReportsCount, pathname, reportsUpdated]);

  return count;
};

export default useOpenReportsCount;
